export default {
  data() {
    return {
      backgroundColors: {
        success: '#36336A',
        error: '#dc2626',
      },
    };
  },
  methods: {
    createNotification(type, msg) {
      this.$toastr.Add({
        title: 'E-Cademy Music',
        msg,
        type,
        timeout: 2500,
        style: { backgroundColor: this.backgroundColors[type] },
        position: 'toast-bottom-left',
        progressbar: false,
      });
    },
  },
};
